import { QueryClient } from '@tanstack/react-query'
import { jwtDecode } from 'jwt-decode'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AuthResponse } from '@/features/auth/types/authTypes'
import { accessTokenSchema } from '@/features/auth/types/accessTokensSchema'
import { refreshTokenSchema } from '@/features/auth/types/refreshTokenSchema'
import { idTokenSchema } from '@/features/auth/types/idTokenSchema'
import { authActions } from '../slices/authSlice'
import { userActions } from '../slices/userSlice'
import { getLocationOptions } from '@/features/location/api/getLocation'
import { locationActions } from '../slices/locationSlice'

type AuthActionProps = {
  authResponse: AuthResponse
  queryClient: QueryClient
}

const authAction = createAsyncThunk('authAction', async ({ authResponse, queryClient }: AuthActionProps, { dispatch }) => {
  const accessTokenData = accessTokenSchema.parse(jwtDecode(authResponse.access_token))
  const refreshTokenData = refreshTokenSchema.parse(jwtDecode(authResponse.refresh_token))
  const idTokenData = idTokenSchema.parse(jwtDecode(authResponse.id_token))
  dispatch(
    authActions.setTokens({
      idToken: authResponse.id_token,
      accessToken: authResponse.access_token,
      accessTokenExpiration: accessTokenData.exp,
      refreshToken: authResponse.refresh_token,
      refreshTokenExpiration: refreshTokenData.exp,
    }),
  )
  dispatch(userActions.setData(idTokenData))
  dispatch(
    userActions.setRoles([...accessTokenData.realm_access.roles, ...(accessTokenData.resource_access?.['realm-management']?.roles || [])]),
  )
  const isGlobalViewer = accessTokenData.realm_access.roles.includes('admin')
  if (!isGlobalViewer) {
    const locationQuery = getLocationOptions(idTokenData.site)
    const location = queryClient.getQueryData(locationQuery.queryKey) ?? (await queryClient.fetchQuery(locationQuery))
    dispatch(locationActions.setLocation(location))
  }
})

export { authAction }
